import axios from "../../../utilities/axios";
import {ContactRequest} from "../../../models/requests/contact.request";

export const contactRequest = async (request: ContactRequest): Promise<void> => {
  try {
    const response = await axios.post<void>(
      `${process.env.REACT_APP_BASE_URL}/contact`,
      {...request},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}